import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";
import Helper from "@/resource/Helper"

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    authenticated: false,
    memberEmail: "",
    accessToken: "",
    commissionToken: "",
    internalToken: "",
    paymentToken: "",
    msgCenterToken: "",
    ticketingToken: "",
    memberId: "",
    profilePic: "",
    deviceId: "",
    groupType: "",
    isPrudential:0,
    policiesPlansType:1,
    memberPhone: "",
    otpSend: false,
    emailOtp: "",
    phoneOtp: "",
    OTPCode: "",
    user: null,
    activePlanId:[],
    activePolicyId:[],
    memberInfoVerifyIdentity:{},
    verifiedIdentitySelectedInfo: {},
    isEnrollPrime:false,
    uniqueID:"",
    isRoot: 0
  },
  mutations: {
    setUserData(state, data) {
      state.user = data;
    },
    setAuthentication(state, status) {
      state.authenticated = status;
    },
    setMemberEmail(state, email) {
      state.memberEmail = email;
    },
    setAccessToken(state, token) {
      state.accessToken = token;
      axios.defaults.headers["Authorization"] =
        token != "" ? "Bearer " + token : "";
    },
    setMemberId(state, memberId) {
      state.memberId = memberId;
    },
    setProfilePic(state, profilePic) {
      state.profilePic = profilePic;
    },
    setDeviceId(state, deviceId) {
      state.deviceId = deviceId;
    },
    setGroupType(state, groupType) {
      state.groupType = groupType;
    },
    setIsPrudential(state,isPrudential){
      state.isPrudential=isPrudential
    },
    setPoliciesPlansType(state, policiesPlansType) {
      state.policiesPlansType = policiesPlansType;
    },
    setMemberPhone(state, data) {
      state.memberPhone = data
    },
    setOtpSend(state, data) {
      state.otpSend = data
    },
    setEmailOtp(state, data) {
      state.emailOtp = data
    },
    setPhoneOtp(state, data) {
      state.phoneOtp = data
    },
    setOtpCode(state, data) {
      state.OTPCode = data
    },
    setActivePlanId(state,data){
      state.activePlanId = data
    },
    setActivePolicyId(state,data){
      state.activePolicyId = data
    },
    setMemberInfoVerifyIdentity(state, data) {
      state.memberInfoVerifyIdentity = data
    },
    setVerifiedIdentitySelectedInfo(state, data) {
        state.verifiedIdentitySelectedInfo = data
    },
    setEnrollPrime(state, data) {
      state.isEnrollPrime = data
    },
    setIsRoot(state, data) {
      state.isRoot = data
    },
    setCommissionToken(state, token) {
      state.commissionToken = token;
    },
    setInternalToken(state, token) {
      state.internalToken = token;
    },
    setPaymentToken(state, token) {
      state.paymentToken = token;
    },
    setMsgCenterToken(state, token) {
      state.msgCenterToken = token;
    },
    setTicketingToken(state, token) {
      state.ticketingToken = token;
    },    
  },
  getters: {
    // count: (state) => {
    //   return state.count;
    // },
    count: state => state.count,
    memberPhone: state => state.memberPhone,
    memberId: state => state.memberId,
    accessToken: state => state.accessToken,
    user: state => state.user,
    groupType: state => state.groupType,
    isPrudential:state=>state.isPrudential,
    policiesPlansType:state=>state.policiesPlansType,
    activePlanId:state =>state.activePlanId,
    activePolicyId: state =>state.activePolicyId,
    memberEmail: state=> state.memberEmail,
    authenticated:state=>state.authenticated,
    memberInfoVerifyIdentity:state=>state.memberInfoVerifyIdentity,
    verifiedIdentitySelectedInfo: state => state.verifiedIdentitySelectedInfo,
    deviceId: state=>state.deviceId,
    OTPCode: state=>state.OTPCode,
    isEnrollPrime: state => state.isEnrollPrime,
    uniqueID: state => state.uniqueID,
    isRoot: state => state.isRoot,
    commissionToken: state => state.commissionToken,
    internalToken: state => state.internalToken,
    paymentToken: state => state.paymentToken,
    msgCenterToken: state => state.msgCenterToken,
    ticketingToken: state => state.ticketingToken,
  },
  actions: {
    async loadUserDetail({ commit }) {
      await axios.get('/get-user-details')
      .then((res)=>{
        const data = res.data.data
        Helper.setUserDetail(data)
        commit('setGroupType',data.employer_type)
        commit('setIsPrudential', data.is_prudential_plan)
        commit('setPoliciesPlansType', data.policies_plans_type)
      })
      .catch(()=>{
        commit('setUserData', null);
        commit('setGroupType',null)
      })
    },
    memberInfoVerifyIdentity: ({commit}, payload) => {
      commit('setMemberInfoVerifyIdentity', payload)
  },
  verifiedIdentitySelectedInfo: ({commit}, payload) => {
      commit('setVerifiedIdentitySelectedInfo', payload)
  },
  },
});
export default store;
